exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.balanceBlock[data-v-692f2d43] {\n    display: -webkit-box;\n    display: flex;\n    -webkit-box-pack: justify;\n            justify-content: space-between;\n}\n.forthing-table[data-v-692f2d43] {\n    border-collapse: separate;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0.25rem;\n    overflow: hidden;\n}\n.center-items[data-v-692f2d43] {\n    width: 100%;\n    margin: 0 auto;\n}\n.aube_user_wallet_check_color[data-v-692f2d43] {\n    color: #450080;\n}\n.aube_stake_check_color[data-v-692f2d43] {\n    color: #00ad69;\n}\n.check_color_position[data-v-692f2d43] {\n    text-align: left;\n}\n", ""]);

// exports
